import { render, staticRenderFns } from "./PublishDynamicView.vue?vue&type=template&id=652edc1a&scoped=true"
import script from "./PublishDynamicView.vue?vue&type=script&lang=js"
export * from "./PublishDynamicView.vue?vue&type=script&lang=js"
import style0 from "./PublishDynamicView.vue?vue&type=style&index=0&id=652edc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652edc1a",
  null
  
)

export default component.exports